import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useRouteVariants } from './hooks/route-variants';
import MainLayout from './layout/MainLayout/MainLayout';

function App() {
  const routeVariants = useRouteVariants();

  return (
      <HelmetProvider>
        <Helmet prioritizeSeoTags={true}>
          {/* Multi-language SEO */}
          {routeVariants.map(({ href, lang }) => <link key={lang} rel="alternate" hrefLang={lang} href={href} />)}
          <link rel="alternate" hrefLang="x-default" href={routeVariants.find(x => x.lang === 'ro')?.href || '/'} />
        </Helmet>
        
        <MainLayout />
      </HelmetProvider>
  );
}

export default App;